import { render, staticRenderFns } from "./QYesNo.vue?vue&type=template&id=641fc4f9&scoped=true"
import script from "./QYesNo.vue?vue&type=script&lang=js"
export * from "./QYesNo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641fc4f9",
  null
  
)

export default component.exports